import { BaseWidgetRenderer } from './base-widget-renderer';
import { SpacerWidgetJsonData, WidgetRenderOptions } from '../../models/element-types';

export class SpacerWidgetRenderer extends BaseWidgetRenderer<SpacerWidgetJsonData> {
    protected override get defaultData(): SpacerWidgetJsonData {
        return {
            id: '',
            type: 'spacer',
            height: '20px',
            shouldUseMaxHeight: true,
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderContent(widgetJsonData: SpacerWidgetJsonData, options: WidgetRenderOptions): HTMLElement {
        const content = document.createElement('div');
        content.classList.add('element-content');

        return content;
    }

    protected override applyAdditionalAttributes(element: HTMLElement, widgetJsonData: SpacerWidgetJsonData): void {
        element.style.height = widgetJsonData.shouldUseMaxHeight ? '100%' : widgetJsonData.height;
    }
}
